import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LocalStorageKeys } from 'src/app/configs/local-storage-keys-config';

@Injectable()
export class ActiveOrganizationInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //read from local storage

    const organizationId = +localStorage.getItem(LocalStorageKeys.activeOrganizationId);

    //set header
    if (organizationId)
      httpRequest = httpRequest.clone({
        headers: httpRequest.headers.set('c-org-id', organizationId.toString())
      });

    return next.handle(httpRequest)
      .pipe(catchError((err) => {
        return throwError(() => err);
      }))
  }
}

export const HttpActiveOrganizationInterceptor = [
  { provide: HTTP_INTERCEPTORS, useClass: ActiveOrganizationInterceptor, multi: true },
];
